export default function HeroVideo() {
  return (
    <section className="relative h-[80vh] min-h-[520px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <video className="h-full w-full object-cover" src="/videos/cranes.mp4" autoPlay loop muted playsInline />
        {/* Light → airy whites; Dark → the original dark wash */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/70 to-white dark:from-slate-900/60 dark:via-slate-900/60 dark:to-slate-950"></div>
      </div>
      <div className="relative z-10 h-full flex items-center">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <h1 className="mt-3 text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight">
              Build with confidence.
              <span className="block text-secondary">Log everything in The Daybook.</span>
            </h1>
            <p className="mt-5 text-lg text-slate-700 dark:text-slate-300">
              Professional operations diary and fleet management for the crane industry. Notes, automated terms generation, maps and more.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href="/contact" className="btn-primary">Request a Demo</a>
            </div>
          </div>
        </div>
      </div>
      <svg className="absolute bottom-0 left-0 right-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 150" preserveAspectRatio="none">
        <path className="fill-white/30 dark:fill-slate-950" d="M0,64L60,96C120,128,240,192,360,186.7C480,181,600,107,720,90.7C840,75,960,117,1080,122.7C1200,128,1320,96,1380,80L1440,64L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"/>
      </svg>
    </section>
  )
}
